import React from 'react'
import { Box, Card, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select, Typography } from '@mui/material'
import { mainBlue, mainGreen, mainPurple, mainRed } from '../../utils/color'
import PickDateWithoutShiftGrow from '../PickDateWithoutShiftGrow'

export default function StatisticsFilters({
	users,
	userFilter,
	orderFilter,
	timePick,
	shift,
	onUserChange,
	onOrderChange,
	onTimeChange,
	onShiftChange,
}) {
	return (
		<Card sx={{ padding: '10px', margin: '0 auto', maxWidth: 992 }}>
			<Box display='flex' justifyContent='center' alignItems='center' gap={2}>
				<FormControl sx={{ minWidth: 120, mt: 1, mb: 1, mr: 1 }} size='small'>
					<InputLabel id='select-label'>Nhân viên</InputLabel>
					<Select
						id='user-select'
						name='user'
						value={userFilter}
						labelId='select-label'
						sx={{ borderRadius: '10px' }}
						input={<OutlinedInput label='Nhân viên' />}
						onChange={onUserChange}>
						<MenuItem value=''>
							<em>- Tất cả -</em>
						</MenuItem>
						{users?.map((user, index) => (
							<MenuItem key={index} value={user.id}>
								{user.name}
							</MenuItem>
						))}
					</Select>
				</FormControl>

				<FormControl sx={{ minWidth: 120, mt: 1, mb: 1 }} size='small'>
					<InputLabel id='select-label'>Đơn hàng</InputLabel>
					<Select
						id='order-select'
						name='order'
						value={orderFilter}
						labelId='select-label'
						sx={{ borderRadius: '10px' }}
						input={<OutlinedInput label='Đơn hàng' />}
						onChange={onOrderChange}>
						<MenuItem value=''>
							<em>- Tất cả -</em>
						</MenuItem>
						<MenuItem value='normal'>Thường</MenuItem>
						<MenuItem value='transfer'>CK</MenuItem>
						<MenuItem value='quickPurchase'>Nhanh</MenuItem>
						<MenuItem value='app'>App</MenuItem>
						<MenuItem value='send'>Chuyển</MenuItem>
						<MenuItem value='receive'>Nhận</MenuItem>
						<MenuItem value='cancel'>Hủy</MenuItem>
					</Select>
				</FormControl>
			</Box>

			<PickDateWithoutShiftGrow time={timePick} setTime={onTimeChange} />

			<Box display='flex' justifyContent='center' sx={{ mt: 2 }}>
				<Chip
					onClick={() => {
						if (!shift.morning) {
							onShiftChange({ morning: true, afternoon: false })
						}
					}}
					size='small'
					sx={{
						cursor: 'pointer',
						mr: 1,
						background: shift.morning ? mainGreen : undefined,
						color: shift.morning ? '#fff' : '#000',
						'&:hover': {
							background: shift.morning ? mainGreen : undefined,
							color: shift.morning ? '#fff' : '#000',
						},
					}}
					label={
						<Typography
							sx={{
								fontSize: '14px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								lineHeight: 1.3,
							}}>
							Sáng
						</Typography>
					}
				/>

				<Chip
					onClick={() => {
						if (!shift.afternoon) {
							onShiftChange({ morning: false, afternoon: true })
						}
					}}
					size='small'
					sx={{
						cursor: 'pointer',
						background: shift.afternoon ? mainGreen : undefined,
						color: shift.afternoon ? '#fff' : '#000',
						'&:hover': {
							background: shift.afternoon ? mainGreen : undefined,
							color: shift.afternoon ? '#fff' : '#000',
						},
						mr: 1,
					}}
					label={
						<Typography
							sx={{
								fontSize: '14px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								lineHeight: 1.3,
							}}>
							Chiều
						</Typography>
					}
				/>

				<Chip
					onClick={() => onOrderChange({ target: { value: orderFilter !== 'send' ? 'send' : '' } })}
					size='small'
					sx={{
						cursor: 'pointer',
						mr: 1,
						background: orderFilter === 'send' ? mainPurple : undefined,
						color: orderFilter === 'send' ? '#fff' : '#000',
						'&:hover': {
							background: orderFilter === 'send' ? mainPurple : undefined,
							color: orderFilter === 'send' ? '#fff' : '#000',
						},
					}}
					label={
						<Typography sx={{ fontSize: '14px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							Chuyển
						</Typography>
					}
				/>

				<Chip
					onClick={() => onOrderChange({ target: { value: orderFilter !== 'receive' ? 'receive' : '' } })}
					size='small'
					sx={{
						cursor: 'pointer',
						background: orderFilter === 'receive' ? mainBlue : undefined,
						color: orderFilter === 'receive' ? '#fff' : '#000',
						'&:hover': {
							background: orderFilter === 'receive' ? mainBlue : undefined,
							color: orderFilter === 'receive' ? '#fff' : '#000',
						},
						mr: 1,
					}}
					label={
						<Typography sx={{ fontSize: '14px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							Nhận
						</Typography>
					}
				/>

				<Chip
					onClick={() => onOrderChange({ target: { value: orderFilter !== 'cancel' ? 'cancel' : '' } })}
					size='small'
					sx={{
						cursor: 'pointer',
						background: orderFilter === 'cancel' ? mainRed : undefined,
						color: orderFilter === 'cancel' ? '#fff' : '#000',
						'&:hover': {
							background: orderFilter === 'cancel' ? mainRed : undefined,
							color: orderFilter === 'cancel' ? '#fff' : '#000',
						},
					}}
					label={
						<Typography sx={{ fontSize: '14px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							Hủy
						</Typography>
					}
				/>
			</Box>
		</Card>
	)
}
